<template>
  <section class="gf-search-company-filters">
    <div class="gf-search-company-filters__content">
      <gf-search-filter-verification></gf-search-filter-verification>
    </div>
    <div class="gf-search-company-filters__mobile-content">
      <gf-overlay-filter
        :is-opened="isOpenedModel"
        submit-button-text="Показать результаты"
        @close="closeFilterOverlay"
      >
        <template #filters>
          <div>
            <gf-search-filter-verification></gf-search-filter-verification>
          </div>
        </template>
      </gf-overlay-filter>
    </div>
  </section>
</template>

<script>
import GfOverlayFilter from '@/shared-modules/shared-components/shared/filter/GfOverlayFilter';
import GfSearchFilterVerification from '@shared/modules/search/components/filters/GfSearchFilterVerification';

export default {
  name: 'GfSearchCompanyFilters',
  components: {
    GfOverlayFilter,
    GfSearchFilterVerification
  },
  props: {
    isOpened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenedModel: false
    };
  },
  watch: {
    isOpened() {
      this.isOpenedModel = this.isOpened;
    }
  },
  mounted() {
    this.isOpenedModel = this.isOpened;
  },
  methods: {
    closeFilterOverlay() {
      this.$emit('close');
      this.isOpenedModel = false;
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-search-company-filters';

#{$this} {
  @include theme.md {
    margin-top: 14px;
  }

  #{$this}__content {
    display: none;

    @include theme.md {
      display: flex;
    }
  }
  #{$this}__mobile-content {
    display: flex;

    @include theme.md {
      display: none;
    }
  }
}
</style>
